import React from "react";

/**
 * Placeholder for the Client view page.
 *
 * This file was previously empty, which caused its import in App.js to resolve
 * to `undefined` and crash the entire React tree ("type is invalid" on every
 * route). This minimal valid component restores rendering; replace with the
 * real client-detail view when implemented.
 */
const Clientview = () => {
  return (
    <div data-testid="client-view-placeholder" style={{ padding: "24px" }}>
      <h2>Client View</h2>
      <p>This page is not yet implemented.</p>
    </div>
  );
};

export default Clientview;
